import { Toast } from 'mint-ui'

// 版本号比较
// Return 1 if a > b
// Return -1 if a < b
// Return 0 if a == b
export function compare (a, b) {
  if (a === b) {
    return 0
  }

  var a_components = a.split('.')
  var b_components = b.split('.')

  var len = Math.min(a_components.length, b_components.length)

  // loop while the components are equal
  for (var i = 0; i < len; i++) {
    // A bigger than B
    if (parseInt(a_components[i]) > parseInt(b_components[i])) {
      return 1
    }
    // B bigger than A
    if (parseInt(a_components[i]) < parseInt(b_components[i])) {
      return -1
    }
  }
  // If one's a prefix of the other, the longer one is greater.
  if (a_components.length > b_components.length) {
    return 1
  }
  if (a_components.length < b_components.length) {
    return -1
  }
  // Otherwise they are the same.
  return 0
}

// 显示tips
export function showTips (tips, callback) {
  let instance = Toast(tips)
  setTimeout(() => {
    instance.close()
    if (callback) {
      callback() // 添加回调
    }
  }, 2000)
}

// js 浮点计算
// 加法
export function accAdd (arg1, arg2) {
  var r1, r2, m, c
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  c = Math.abs(r1 - r2)
  m = Math.pow(10, Math.max(r1, r2))
  if (c > 0) {
    var cm = Math.pow(10, c)
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''))
      arg2 = Number(arg2.toString().replace('.', '')) * cm
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm
      arg2 = Number(arg2.toString().replace('.', ''))
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''))
    arg2 = Number(arg2.toString().replace('.', ''))
  }
  return (arg1 + arg2) / m
}

// 乘法
export function accMul (arg1, arg2) {
  var m = 0
  var s1 = arg1.toString()
  var s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

// 减法
export function accSub (arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2)) // last modify by deeka //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

/**
 * 文本框根据输入内容自适应高度
 * @param                {HTMLElement}        输入框元素
 * @param                {Number}             设置光标与输入框保持的距离(默认0)
 * @param                {Number}             设置最大高度(可选)
 */
export function autoTextarea (elem, extra, maxHeight) {
  extra = extra || 0
  var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window
  var isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera')
  var addEvent = function (type, callback) {
    elem.addEventListener ? elem.addEventListener(type, callback, false) : elem.attachEvent('on' + type, callback)
  }
  var getStyle = elem.currentStyle ? function (name) {
    var val = elem.currentStyle[name]
    if (name === 'height' && val.search(/px/i) !== 1) {
      var rect = elem.getBoundingClientRect()
      return rect.bottom - rect.top -
        parseFloat(getStyle('paddingTop')) -
        parseFloat(getStyle('paddingBottom')) + 'px'
    }
    return val
  } : function (name) {
    return window.getComputedStyle(elem, null)[name]
  }
  var minHeight = parseFloat(getStyle('height'))
  elem.style.resize = 'none'
  var change = function () {
    var scrollTop
    var height
    var padding = 0
    var style = elem.style
    if (elem._length === elem.value.length) return
    elem._length = elem.value.length
    if (!isFirefox && !isOpera) {
      padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'))
    }
    scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    elem.style.height = minHeight + 'px'
    if (elem.scrollHeight > minHeight) {
      if (maxHeight && elem.scrollHeight > maxHeight) {
        height = maxHeight - padding
        style.overflowY = 'auto'
      } else {
        height = elem.scrollHeight - padding
        style.overflowY = 'hidden'
      }
      style.height = height + extra + 'px'
      scrollTop += parseInt(style.height) - elem.currHeight
      document.body.scrollTop = scrollTop
      document.documentElement.scrollTop = scrollTop
      elem.currHeight = parseInt(style.height)
    }
  }
  addEvent('propertychange', change)
  addEvent('input', change)
  addEvent('focus', change)
  change()
}

// 格式化时间
const timeFormat = function (date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

export function transformDate (date) {
  var date_obj = {
    cn_date: date.getMonth() + 1 + '月' + date.getDate() + '日' + '周' + '日一二三四五六'.split('')[date.getDay()],
    time: date.getHours() + ':' + date.getMinutes(),
    week: '周' + '日一二三四五六'.split('')[date.getDay()],
    param: timeFormat(date, 'yyyy/MM/dd hh:mm'),
    date: timeFormat(date, 'yyyy/MM/dd')
  }
  return date_obj
}

// 时间格式还原
export function restoreDate (date, hour, minute) {
  var _now = new Date()
  var _now_month = _now.getMonth() + 1
  var _now_year = _now.getFullYear()
  var _date = date.slice(0, -3).split('月')
  var _year = (_date[0] >= _now_month) ? _now_year : _now_year + 1
  var _hour = hour.slice(0, -1)
  var _minute = minute.slice(0, -1)
  if (_hour.length === 1) {
    _hour = '0' + _hour
  }
  if (_minute.length === 1) {
    _minute = '0' + _minute
  }
  return {
    param: _year + '/' + _date[0] + '/' + _date[1] + ' ' + _hour + ':' + _minute,
    date: date.slice(0, -2),
    week: date.slice(-2),
    time: _hour + ':' + _minute
  }
}

export function formatDay (date, type) {
  // 时间格式化
  date = date || new Date()
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  if (type === 'line') {
    return year + '-' + month + '-' + day
  } else {
    if (type === 'year') {
      return year + '年' + month + '月' + day + '日 ' + getDay(date, 'day')
    } else {
      return month + '月' + day + '日'
    }
  }
}

export function getDay (date, type) {
  // 获取周几
  var _list = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  var _listMon = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  var _date = date || new Date()
  // 返回date格式
  if (type === 'day') {
    return _listMon[_date.getDay()]
  } else {
    return _list[_date.getDay()]
  }
}

export function getPlusDate (num, dayStr) {
  // 获取前后几天的日期
  var _num = parseInt(num) || 0
  var _limit = _num * 24 * 60 * 60 * 1000
  var _date = new Date()
  var _times = 0
  var _startDate = {}
  if (dayStr) {
    _startDate.month = dayStr.substring(5, dayStr.lastIndexOf('-'))
    _startDate.day = dayStr.substring(dayStr.length, dayStr.lastIndexOf('-') + 1)
    _startDate.year = dayStr.substring(0, dayStr.indexOf('-'))
    _times = Date.parse(_startDate.month + '/' + _startDate.day + '/' + _startDate.year) + _limit
  } else {
    _times = _date.getTime() + _limit
  }
  // 返回date格式
  return new Date(_times)
}

// 截取字符串
export function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r !== null) {
    return unescape(r[2])
  }
  return null
}

// 数据上报
export function postCnzzData (category_id, type_value, label, val) {
  var _href = window.location.href || ''
  var _label = label || 0
  var _val = parseInt(val) || 0
  var _isDev = (_href.indexOf('apitest') !== -1) || (_href.indexOf('localhost') !== -1) // 测试环境
  if (!_isDev) {
    if (category_id && window._czc) {
      try {
        if (_label) {
          if (type_value) {
            window._czc.push(['_trackEvent', category_id, type_value, _label, _val])
          } else {
            window._czc.push(['_trackEvent', category_id, '点击', _label, _val])
          }
        } else {
          if (type_value) {
            window._czc.push(['_trackEvent', category_id, type_value])
          } else {
            window._czc.push(['_trackEvent', category_id, '点击'])
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}

// 事件数据上报-百度统计
export function postBaiduData (category, action, opt_label, opt_value) {
  // category：要监控的目标的类型名称
  // action：用户跟目标交互的行为，如"播放"、"暂停"
  // opt_label：事件的一些额外信息，通常可以是歌曲的名称
  // opt_value：事件的一些数值信息，比如权重、时长
  var _category = category || '-'
  var _action = action || '-'
  var _opt_label = opt_label || '-'
  var _opt_value = opt_value || 0
  if (_hmt && _category) {
    _hmt.push(['_trackEvent', _category, _action, _opt_label, _opt_value])
  }
}

// 数据上报 pv
export function postCnzzDataTrack (contentUrl, refererUrl) {
  var _href = window.location.href || ''
  var _isDev = (_href.indexOf('apitest') !== -1) || (_href.indexOf('localhost') !== -1) // 测试环境
  var _contentUrl = '/enterprise/dist' + contentUrl
  var _refererUrl = 'https://wx.dudubashi.com/enterprise/dist' + refererUrl
  if (!_isDev) {
    if (contentUrl && window._czc) {
      try {
        window._czc.push(['_trackPageview', _contentUrl, _refererUrl])
      } catch (e) {
        console.log(e)
      }
    }
  }
}

/**
 * js截取字符串，中英文都能用
 * @param str：需要截取的字符串
 * @param len: 需要截取的长度
 */
export function cutstr (str, len) {
  var str_length = 0
  var str_len = 0
  var str_cut = ''
  str_len = str.length
  for (var i = 0; i < str_len; i++) {
    var a = str.charAt(i)
    str_length++
    if (decodeURIComponent(a).length > 4) {
      // 中文字符的长度经编码之后大于4
      str_length++
    }
    if (str_length > len) {
      str_cut = str_cut.concat('...')
      return str_cut
    } else {
      str_cut = str_cut.concat(a)
    }
  }
  // 如果给定字符串小于指定长度，则返回源字符串；
  if (str_length <= len) {
    return str
  }
}

/**
 * 对象扩展
 * @param source [object] 需要复制的对象
 * @param deep [boolean] 是否进行深复制
 */
export function extendObject (source, deep) {
  function isPlainObject (obj) {
    return obj && (typeof obj === 'object') && Object.getPrototypeOf(obj) === Object.prototype
  }
  var isArray = Array.isArray || function (object) { return object instanceof Array }
  var target = {}
  if (isArray(source)) {
    target = []
  }
  for (var key in source) {
    if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
      target[key] = extendObject(source[key], deep)
    } else if (source[key] !== undefined) {
      if (isArray(source)) {
        target.push(source[key])
      } else {
        target[key] = source[key]
      }
    }
  }
  // 返回新对象
  return target
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js